<div bind:this="{d}">rendere ...</div>

<script lang="typescript">import marked from "marked";
import {onMount} from "svelte";
let source;
let d;
onMount(async () => {
  d.innerHTML = marked(source);
});
export {
  source
};
</script>
